import * as React from "react";

function SchedularDate(props: React.SVGProps<SVGSVGElement>) {
  return (
    <svg
    xmlns="http://www.w3.org/2000/svg"
    width="20"
    height="20"
    fill="none"
    viewBox="0 0 20 20"
  >
    <g clipPath="url(#clip0_2_5508)">
      <path
        fill="#1C1C1C"
        stroke="#1C1C1C"
        strokeWidth="0.2"
        d="M17.91 12.783V5.02c0-.808-.657-1.465-1.465-1.465h-.952v.732a.732.732 0 1 1-1.465 0v-.732h-3.332v.732a.732.732 0 1 1-1.465 0v-.732H5.935v.732a.732.732 0 1 1-1.465 0v-.732h-.915c-.808 0-1.465.657-1.465 1.465v11.425c0 .808.657 1.465 1.465 1.465h12.89c.808 0 1.465-.657 1.465-1.465a.732.732 0 1 1 1.465 0 2.933 2.933 0 0 1-2.93 2.93H3.555a2.933 2.933 0 0 1-2.93-2.93V5.02a2.933 2.933 0 0 1 2.93-2.93h.915v-.733a.732.732 0 1 1 1.465 0v.733h3.296v-.733a.732.732 0 1 1 1.465 0v.733h3.332v-.733a.732.732 0 1 1 1.465 0v.733h.952a2.933 2.933 0 0 1 2.93 2.93v7.763a.732.732 0 1 1-1.465 0Zm-2.417-.55v1.722c0 .808-.657 1.465-1.465 1.465h-1.72a1.467 1.467 0 0 1-1.466-1.465v-1.721c0-.808.657-1.465 1.465-1.465h1.721c.808 0 1.465.657 1.465 1.465Zm-1.464 1.722v-1.721h-1.722v1.721h1.722Z"
      ></path>
    </g>
    <defs>
      <clipPath id="clip0_2_5508">
        <path fill="#fff" d="M0 0h20v20H0z"></path>
      </clipPath>
    </defs>
  </svg>
  );
}

export default SchedularDate;
